export const getStoredFilter = (storedFilterName: string) => {
  try {
    return JSON.parse(localStorage.getItem(storedFilterName) ?? 'null') ?? undefined;
  } catch {
    return undefined;
  }
};
